import { render } from "./UpdatedAanmeldenForm.vue?vue&type=template&id=7fffa3f1&scoped=true"
import script from "./UpdatedAanmeldenForm.vue?vue&type=script&lang=js"
export * from "./UpdatedAanmeldenForm.vue?vue&type=script&lang=js"

import "./UpdatedAanmeldenForm.vue?vue&type=style&index=0&id=7fffa3f1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fffa3f1"]])

export default __exports__